import {LatLng} from '../../../react-app-env';
import {getBounds} from 'geolib';
import {centerOf, distanceBetween, fitBounds, toGeoLibLatLng} from '../../../utils/GeoLibUtils';

const MIN_THRESHOLD_OUTLIER_FILTERING = 5;

/**
 * Calculates the initial bounds for the given coordinates, removing outliers first.
 *
 * @param {LatLng[]} coords Coordinates to calculate the bounds for.
 */
export function calculateInitialBounds(coords: LatLng[]): any {
  const trimmedCoords = removeOutliers(coords);
  const bounds = getBounds(trimmedCoords.map(c => toGeoLibLatLng(c)));

  return fitBounds(
      {
        ne: { lat: bounds.maxLat, lng: bounds.maxLng },
        sw: { lat: bounds.minLat, lng: bounds.minLng }
      },
      {
        width:  window.innerWidth - 320, // Account for sidebar width
        height: window.innerHeight
      }
  );
}

/**
 * Removes outlier coordinates that are too far away from the center.
 *
 * @param {LatLng[]} coords Coordinates to filter.
 */
function removeOutliers(coords: LatLng[]): LatLng[] {
  if (!coords || coords.length <= MIN_THRESHOLD_OUTLIER_FILTERING) {
    return coords;
  }

  const center = centerOf(coords);
  if (!center) {
    return coords;
  }

  let distanceStdDev = 0;
  coords.forEach(function(c) {
    distanceStdDev += distanceBetween(center, c) / coords.length;
  });

  const filtered = coords.filter(function(c) {
    return distanceBetween(center, c) < 5 * distanceStdDev;
  });

  if (filtered.length === coords.length) {
    return filtered;
  } else {
    return removeOutliers(filtered);
  }
}
